import { render } from "./Tutorials.vue?vue&type=template&id=f3cd2f04&scoped=true"
import script from "./Tutorials.vue?vue&type=script&lang=js"
export * from "./Tutorials.vue?vue&type=script&lang=js"

import "./Tutorials.vue?vue&type=style&index=0&id=f3cd2f04&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cd2f04"]])

export default __exports__